import { Component, OnInit } from '@angular/core';
import { PainelinsumoService } from '../../../services/painelinsumo.service';
import { ToastService } from '../../../services/toast.service';
import { DepositoInsumo } from '../../../types/DepositoInsumo.type';

@Component({
  selector: 'app-deposito',
  templateUrl: './deposito.component.html',
  styleUrl: './deposito.component.css'
})
export class DepositoComponent implements OnInit{

  depositos: DepositoInsumo[] = []

  constructor(private painelService: PainelinsumoService, private toastService: ToastService){}

  ngOnInit(){
    this.carregarDepositos();
  }

  carregarDepositos(){

    this.painelService.getDepositos().subscribe({
      next: (data) => {
        this.depositos = data
      },
      error: (error) => {
        this.toastService.erro("Erro", error.error.message);
      }
    })
  }
}
